import React, { useState, useEffect } from "react";
import Modal from "./Modal";

const preStyle = {
  background: "#f8f9fa",
  padding: "12px",
  margin: "0",
  fontSize: "13px",
};

// Reading a step's full JSON result -- the inline <pre> in StepNode
// truncates at 220px, which is unreadable for anything with more than a
// couple of line items.
const JsonModal = ({ open, onClose, title, data }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (open) setCopied(false);
  }, [open]);

  const json = JSON.stringify(data, null, 2);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(json)
      .then(() => setCopied(true))
      .catch(() => {});
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      headerExtra={
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleCopy}>
          {copied ? "Copied!" : "Copy"}
        </button>
      }
    >
      <pre style={preStyle}>{json}</pre>
    </Modal>
  );
};

export default JsonModal;
